import { CircularProgress } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import React from 'react';
import './loading-alert.scss';

interface LoadingAlertProps {
  message: string;
}

export const LoadingAlert: React.FC<LoadingAlertProps> = ({ message }) => {
  return (
    <Alert
      severity="info"
      className='loading-alert'
      iconMapping={{ info: <CircularProgress color='inherit' size={16} /> }}
    >
      <p className="loading-alert__text">{message}</p>
    </Alert>
  );
};

export default LoadingAlert;
